exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-form .el-input[data-v-169253de]{width:100%}.uploadImg[data-v-169253de]{width:100px}\n", ""]);

// exports
